import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import BeforeAfter from './components/BeforeAfter';
import Gallery from './components/Gallery';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function App() {
  const path = window.location.pathname;

  if (path === '/privacy-policy') {
    return (
      <div className="App">
        <PrivacyPolicy />
      </div>
    );
  }

  if (path === '/terms-of-service') {
    return (
      <div className="App">
        <TermsOfService />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Services />
        <BeforeAfter />
        <Gallery />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
